import { FormSectionHeader, Heading, Loader } from "@/components";
import usePayment360Report from "./usePayment360Report";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui";
import { images } from "@/assets";
import { cn, formatAmount } from "@/lib/utils";
import { DataTableCollapsibleRow } from "@/components/DataTableCollapsibleRow";
import { InfoIcon } from "lucide-react";
import { Filter } from "./Filter";
import { Header } from "./Header";

const Payment360Report = () => {
  const {
    breadcrumbData,
    isMobile,
    summaryCard,
    columns,
    openFilter,
    onCancelFilter,
    onFilterBtnClick,
    filterData,
    tableData,
    subColumns,
    onFilter,
    isLoadingReport,
    isRefetchingPaymentReport,
    fromDashboard,
    onBackClick,
    currentFinanceYear,
    selectedOption,
    onOptionChanges
  } = usePayment360Report();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={
              <span>
                Payment 360 Report{" "}
                <span className="text-[12px]">(FY-{currentFinanceYear})</span>
              </span>
            }
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
          {fromDashboard ? (
            <></>
          ) : (
            isMobile && (
              <Header onFilterBtnClick={onFilterBtnClick} option={selectedOption} onOptionChanges={onOptionChanges} />
            )
          )}
        </div>
        {fromDashboard ? (
          <></>
        ) : (
          !isMobile && (
            <Header onFilterBtnClick={onFilterBtnClick} option={selectedOption} onOptionChanges={onOptionChanges} />
          )
        )}
      </div>

      <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[20px] mb-6 shadow-sm">
        <div className="flex flex-row gap-3 items-start justify-start">
          <FormSectionHeader>Expense Budget Vs. Actuals</FormSectionHeader>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="mx-1 mt-0" type="button">
                <InfoIcon className="h-5 w-5 stroke-primary" />
              </TooltipTrigger>
              <TooltipContent>
                <div className="flex flex-col text-[14px]">
                  <span className="border-b-1 py-3">
                    <b>Committed</b> - Approved + Posted <br />
                    but not paid (Invoice Document)
                  </span>
                  <span className="border-b-1 py-3">
                    <b>Actuals</b> - Paid invoices
                  </span>
                  <span className="border-b-1 py-3">
                    <b>Var-Com</b> - Budget Amt. - Committed Amt.
                  </span>
                  <span className="py-3">
                    <b>Var-Act</b> - Budget Amt. - Actual Amt.
                  </span>
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>

        <div className="bg-primary rounded-sm grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {summaryCard?.map((data: any, index: number) => (
            <div
              className={cn(
                "flex flex-row md:items-center lg:justify-center text-white my-7 mx-4 gap-3",
                index !== summaryCard.length - 1 ? "lg:border-r-1" : ""
              )}
              key={`summary-card-${index}`}
            >
              <div className="bg-white p-3 rounded-full">
                <img src={images.check_doc} className="h-8 w-8" />
              </div>
              <div className="flex flex-col text-[14px]">
                <span>
                  {data?.title} : {data?.count || 0}
                </span>
                <span>
                  {data?.amountTitle} : {formatAmount(data?.amount)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isLoadingReport || isRefetchingPaymentReport ? (
        <Loader />
      ) : (
        <DataTableCollapsibleRow
          columns={columns}
          nestedColumns={[subColumns]}
          data={tableData}
        />
      )}

      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={onFilter}
        />
      )}
    </div>
  );
};

export default Payment360Report;
